import { Route } from 'react-router';

import { ProtectedRoute } from '@app-velocity/request-gateway';

import { AuthRoutesPaths } from '@app-velocity/libs/auth';

import { PaymentSuccess } from '../pages/PaymentSuccess';
import { PaymentFailed } from '../pages/PaymentFailed';
import { PaymentStatusWrapper } from '../components/PaymentStatusWrapper';
import { Subscribe } from '../pages/Subscribe';

const LayoutRoute = Route;

export const PaymentRoutes = (
  <>
    <LayoutRoute
      element={
        <ProtectedRoute storeOriginalUrl redirectPath={AuthRoutesPaths.Login} />
      }
    >
      <Route path="/subscribe" element={<Subscribe />} />
    </LayoutRoute>
    <LayoutRoute path="/payment" element={<PaymentStatusWrapper />}>
      <Route path="success" element={<PaymentSuccess />} />
      <Route path="failed" element={<PaymentFailed />} />
    </LayoutRoute>
  </>
);
